import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import {dayClassification, pickingOrderClassification} from '../../common/dictionaries/classification';

const INITIAL_STATE = {
  'loading': false,
  'filterText': '',
  'shiftData': {},
  'list': [],
  'filteredList': [],
};

const FORM_INITIAL_STATE = {
  'loading': false,
  'modificationDate': '',
  'values': {
    'name': '',
    'orders': [],
    'labelsEmissionTime': '00:00',
    'dispatchTime': '00:00',
    'days': [],
    'status': true,
  },
};

const parseDays = (days) => {
  return days.map((item) => {
    return dayClassification[item];
  }).join(', ');
};

const parseOrderTypes = (orders) => {
  return orders.map((item) => {
    return pickingOrderClassification[item];
  }).join(', ');
};

const filterList = (list, value) => {
  return [...list].filter((element) => {
    return (
      [
        element.name || '',
        element.labelsEmissionTime || '',
        element.dispatchTime || '',
        parseDays(element.days) || '',
        parseOrderTypes(element.orders) || '',
        element.status ? 'Activo' : 'Inactivo',
      ].some((text) =>
        text.toLowerCase().includes(value.toLowerCase()) || value === ''
      )
    );
  });
};

export const shifts = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_SHIFTS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_SHIFTS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'filteredList': action.response.data,
    }),
    [ActionTypes.FETCHED_SHIFTS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'filteredList': [],
    }),
    [ActionTypes.CHANGE_SHIFTS_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterText': action.payload,
    }),
    [ActionTypes.FILTER_SHIFTS]: (state, action) => ({
      ...state,
      'filteredList': [...filterList(state.list, action.payload)],
    }),
  })(state, action);
};

export const shift = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_SHIFT]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_SHIFT]: (state, action) => ({
      ...state,
      'loading': false,
      'shiftData': action.response.data,
    }),
    [ActionTypes.FETCHED_SHIFT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'shiftData': {},
    }),
  })(state, action);
};

export const shiftForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHING_SHIFT]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_SHIFT]: (state, action) => ({
      ...state,
      'loading': false,
      'modificationDate': action.response.data.modificationDate,
      'values': {
        'name': action.response.data.name,
        'orders': action.response.data.orders,
        'labelsEmissionTime': action.response.data.labelsEmissionTime,
        'dispatchTime': action.response.data.dispatchTime,
        'days': action.response.data.days,
        'status': action.response.data.status,
      },
    }),
    [ActionTypes.FETCHED_SHIFT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'modificationDate': '',
      'values': {
        'name': '',
        'orders': [],
        'labelsEmissionTime': '00:00',
        'dispatchTime': '00:00',
        'days': [],
        'status': true,
      },
    }),
  })(state, action);
};
